/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import * as React from "react";
import Dialog from "@mui/material/Dialog";
import "./userExpirePopup.scss";
import { DialogContentText } from "@mui/material";

export default function UserExpirePopup(props: any) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    props.closePopup(false);
  };

  React.useEffect(() => {
    setOpen(props.openUserExiperPopup);
  }, [props.openUserExiperPopup]);

  return (
    <div className="userExpireWrapper" >
      <Dialog open={open} onClose={handleClose}>
        <DialogContentText>
          <div className="userExpireMain">
            <div className="userExpireHeader">
              <span className="userExpireTitle">
                Ready to Take the Next Step? <br /> Upgrade Your Account to a
                Subscription
              </span>{" "}
            </div>
            <div className="userExpireDetails">
              <p>
                Your trial plan is no longer valid. We hope you were able to spend
                the trial period exploring numerous documents on our platform.
              </p>
              <p>
                Purchase the commercial version to gain access to thousands of
                additional documents and numerous features.
              </p>
              <p>
                Contact us at{" "}
                <a href="mailto:support@infraclear.com" className="emailText">
                  {" "}
                  support@infraclear.com
                </a>{" "}
                to purchase a subscription.
              </p>
              <p>
                Thank you for trying using Infraclear, and we hope to continue
                helping you in the future.
              </p>
            </div>
          </div>
        </DialogContentText>
      </Dialog>
    </div>
  );
}